var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B440A1"
    },
    d: "M388.896,233.617c0-37.088-30.06-67.148-67.148-67.148c-2.227,0-4.421,0.112-6.592,0.325   c-23.166-40.322-66.666-67.472-116.512-67.472c-5.887,0-11.684,0.38-17.358,1.108l172.916,278.674h34.693   c18.544,0,33.35-15.03,33.35-33.574L388.896,233.617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#B440A1"
    },
    d: "M456.044,233.617h-34.693l0.895,111.913h33.798c30.899,0,55.956-25.057,55.956-55.956   S486.943,233.617,456.044,233.617z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FA9647"
    },
    d: "M422.246,345.53C421.877,345.552,422.615,345.53,422.246,345.53L422.246,345.53z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FE4382"
    },
    d: "M477.307,289.574c0-30.899-25.057-55.956-55.956-55.956h-32.455h-34.693  c0-37.088-30.06-67.148-67.148-67.148c-2.227,0-4.421,0.112-6.592,0.325c-20.435-35.566-56.695-60.892-99.177-66.364  C115.315,108.947,64.35,165.34,64.35,233.617c-30.899,0-55.956,25.057-55.956,55.956S33.451,345.53,64.35,345.53h100.721  c0,18.544,15.03,33.574,33.574,33.574h155.558c18.544,0,33.574-15.03,33.574-33.574h34.469  C452.63,344.948,477.307,320.104,477.307,289.574z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FCD999"
    },
    cx: 221.027,
    cy: 155.279,
    r: 8.393
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FEECCC"
    },
    cx: 422.47,
    cy: 300.765,
    r: 8.393
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBC566"
    },
    cx: 137.093,
    cy: 295.169,
    r: 8.393
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FEECCC"
    },
    cx: 137.093,
    cy: 228.022,
    r: 8.393
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 103.519,
    cy: 261.596,
    r: 8.393
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B233"
    },
    cx: 388.896,
    cy: 423.869,
    r: 8.393
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBC566"
    },
    cx: 355.322,
    cy: 457.443,
    r: 8.393
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B233"
    },
    cx: 198.645,
    cy: 54.557,
    r: 8.393
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B233"
    },
    cx: 8.393,
    cy: 499.41,
    r: 8.393
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B233"
    },
    cx: 411.279,
    cy: 106.037,
    r: 8.393
  })), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FBC566"
    },
    cx: 377.705,
    cy: 72.463,
    r: 8.393
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#F9B233"
    },
    cx: 461.639,
    cy: 12.59,
    r: 8.393
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEECCC"
    },
    points: "58.754,379.104 72.998,415.22 109.115,429.465 72.998,443.709 58.754,479.825 44.51,443.709   8.393,429.465 44.51,415.22 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCD999"
    },
    points: "316.153,328.743 330.397,364.86 366.514,379.104 330.397,393.348 316.153,429.465    301.909,393.348 265.792,379.104 301.909,364.86  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FCD999"
    },
    points: "198.645,211.235 212.889,247.351 249.005,261.596 212.889,275.84 198.645,311.956    184.401,275.84 148.284,261.596 184.401,247.351  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#FEECCC"
    },
    points: "461.639,100.442 475.884,136.558 512,150.802 475.884,165.046 461.639,201.163   447.395,165.046 411.279,150.802 447.395,136.558 "
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/cloud.16fe8c6a579b605719977916b3ffad45.svg";
export { ForwardRef as ReactComponent };